/* eslint-disable */
import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from '../views/layout/index.vue'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'layout',
    redirect: '/home',
    component: layout,
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Home
      },
      {
        path: '/info',
        name: 'Details',
        component: () => import('@/views/Details.vue')
      },
      {
        path: '/team',
        name: 'Team',
        component: () => import('@/views/Team.vue')
      },
      {
        path: '/about',
        name: 'About',
        component: () => import('@/views/About.vue')
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue')
  },
  {
    path: '/forget',
    name: 'Forget',
    component: () => import('@/views/Forget.vue')
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    const loading = Vue.prototype.$loading({
      lock: false,
      background: 'rgba(0, 0, 0, 0.2)'
    });
    setTimeout(() => {
      loading.close()
    }, 500)
    return {
      x: 0, y: 0
    }
  }
})

export default router
